import React, { useRef, useState, useEffect, useMemo } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Button,
  Grid,
  Paper,
  Fade,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  DialogContentText,
  CircularProgress,
  Breadcrumbs,
  Link as MUILink,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
} from "@mui/material";
//import { Editor } from "@tinymce/tinymce-react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiServices } from "../../utils/ApiService";
import JSZip from "jszip";
import { pdfjs } from "react-pdf";
import { useSnackbar } from "notistack";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileFormatComponent from "./FileFormatComponent";
import SinglePdfViewer from "./SinglePdfViewer";
import DeleteIcon from "@mui/icons-material/Delete";

import SyncfusionWordEditor from "./SyncfusionWordEditor";

import UploadQueryFilesDialog from "./UploadQueryFilesDialog";

// Set up PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

// function TabPanel({ children, value, index }) {
//   return (
//     <Fade in={value === index} timeout={500}>
//       <div role="tabpanel" hidden={value !== index} style={{ width: "100%" }}>
//         {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
//       </div>
//     </Fade>
//   );
// }

export default function ProcessorFileView() {
  const [tab, setTab] = useState(0);
  const [editorContent, setEditorContent] = useState("");
  const [ovEditorContent, setOVEditorContent] = useState("");
  const [queryLoading, setQueryLoading] = useState(false);
  const [templateLoading, setTemplateLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDelModal, setOpenDelModal] = useState(false);
  const { id } = useParams();
  const hasFetched = useRef(false);
  const { enqueueSnackbar } = useSnackbar();
  const [queryRows, setQueryRows] = useState([]);
  const [fileRows, setFileRows] = useState({});
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const userRole = useMemo(
    () => JSON.parse(localStorage.getItem("user"))?.role,
    [],
  );
  const arrDocumentCategory = [
    "Title deed",
    "Mother Document",
    "Sale Agreement",
    "Revenue record",
    "EC",
  ];
  const [queries, setQueries] = useState([
    { category: "", requiredFiles: "", query: "" },
  ]);
  const [delReason, setDelReason] = useState("");

  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);
  const handleCloseModal = () => setModalOpen(false);

  const handleOpenDelModal = (id) => {
    setOpenDelModal(true);
    setSelectedQueryId(id);
    setDelReason("");
  };
  const handleCloseDelModal = () => {
    setOpenDelModal(false);
    setSelectedQueryId(null);
    setDelReason("");
  };
  const [selectedQueryId, setSelectedQueryId] = useState(null);
  const [openDeletedModal, setOpenDeletedModal] = useState(false);
  const [openQryUploadModal, setOpenQryUploadModal] = useState(false);
  const [deletedRows, setDeletedRows] = useState([]);

  const [overviewReloadKey, setOverviewReloadKey] = useState(0);
  const workEditorRef = useRef(null); // tab === 1
  const overviewEditorRef = useRef(null); // tab === 4

  useEffect(() => {
    if (tab === 1) {
      requestAnimationFrame(() => {
        workEditorRef.current?.resizeEditor();
      });
    }

    if (tab === 4) {
      requestAnimationFrame(() => {
        overviewEditorRef.current?.resizeEditor();
      });
    }
  }, [tab]);

  const handleEditorChange = (content) => {
    setEditorContent(content);
    localStorage.setItem("documentContent", content);
  };

  const [saveLoading, setSaveLoading] = useState(false);
  
  const handleSaveFile = async () => {
    if (saveLoading) return;

    setSaveLoading(true);

    try {
      const response = await fetch(
        `https://yaazhlegal.org.in/documenteditor/save-by-fileid/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: tab === 1 ? editorContent : ovEditorContent,
        }
      );

      if (!response.ok) {
        throw new Error("Save failed");
      }

      enqueueSnackbar("File saved successfully", {
        variant: "success",
      });
    } catch (err) {
      enqueueSnackbar("File save failed", {
        variant: "error",
      });
    } finally {
      setSaveLoading(false);
    }
  };

  const handleConfirmComplete = () => {
    setOpenConfirm(false);
    handleComplete();
  };

  const handleCancelComplete = () => {
    setOpenConfirm(false);
  };

  const handleComplete = async () => {
    try {
      const userId = JSON.parse(localStorage.getItem("user"))?.id ?? "";
      const res = await ApiServices.put(`file/complete-file`, {
        fileId: id,
        userId,
      });
      if (res.status === 200) {
        const userData = JSON.parse(localStorage.getItem("user"));
        enqueueSnackbar("File Completed", { variant: "success" });

        if (userData?.role === "Processor") {
          navigate("/processor-assigned-files");
        } else if (
          ["Super Admin", "Branch Admin", "Login Officer"].includes(
            userData?.role,
          )
        ) {
          navigate("/assigned-files");
        }
      }
    } catch (error) {
      enqueueSnackbar("Failure", { variant: "error" });
    }
  };

  const setQryToBankStatus = async () => {
    try {
      const userId = JSON.parse(localStorage.getItem("user"))?.id ?? "";
      const res = await ApiServices.put(`file/set-query-to-bank`, {
        fileId: id,
        userId,
      });
      if (res.status === 200) {
        const userData = JSON.parse(localStorage.getItem("user"));
        enqueueSnackbar(`Set status "Query to Bank" successfully.`, {
          variant: "success",
        });

        if (userData?.role === "Processor") {
          navigate("/processor-assigned-files");
        } else if (
          ["Super Admin", "Branch Admin", "Login Officer"].includes(
            userData?.role,
          )
        ) {
          navigate("/assigned-files");
        }
      }
    } catch (error) {
      enqueueSnackbar("Failure", { variant: "error" });
    }
  };

  // const fetchTemplate = async () => {
  //   setTemplateLoading(true);
  //   try {
  //     const response = await ApiServices.get(`file/download/template/${id}`);
  //     if (response?.status === 200) {
  //       // const footerHtml = `
  //       //   <div style="text-align: center;">
  //       //     <img src="https://yaazhlegal.org.in/footer.png" alt="Footer" style="width: 816px; height: auto;" />
  //       //   </div>
  //       // `;

  //       const alreadyHasHeader = response.data.includes("header.png");
  //       //const alreadyHasFooter = response.data.includes("footer.png");

  //       let fullHtml = response.data;

  //       // Inject header at the top
  //       if (!alreadyHasHeader) {
  //         let headerHtml = '';
  //         const userData = JSON.parse(localStorage.getItem("user"));
  //         if (userData.branch == 2)
  //         {
  //           headerHtml = `<div style="text-align: center;">
  //               <img src="https://yaazhlegal.org.in/ten-header.png" alt="Header" style="width: 816px; height: auto;" />
  //             </div>`;
  //         }
  //         else if (userData.branch == 5)
  //         {
  //           headerHtml = `<div style="text-align: center;">
  //               <img src="https://yaazhlegal.org.in/cbe-header.png" alt="Header" style="width: 816px; height: auto;" />
  //             </div>`;
  //         }
  //         else
  //         {
  //           headerHtml = `<div style="text-align: center;">
  //               <img src="https://yaazhlegal.org.in/tvl-header.png" alt="Header" style="width: 816px; height: auto;" />
  //             </div>`;
  //         }

  //         fullHtml = `${headerHtml}${fullHtml}`;
  //       }

  //       // Footer:
  //       // if (!alreadyHasFooter) {
  //       //   fullHtml = fullHtml.replace('{{footer}}', `${footerHtml}`);
  //       // }

  //       setEditorContent(fullHtml);
  //     }
  //   } catch (error) {
  //     console.error("Failed to fetch template:", error);
  //     setEditorContent("Error loading template.");
  //   } finally {
  //     setTemplateLoading(false);
  //   }
  // };

  const fetchPDFs = async () => {
    setPdfLoading(true);
    try {
      const res = await ApiServices.get(`/file/assigned-files/pdf/${id}`, {
        responseType: "blob",
      });

      if (res?.status === 200) {
        const zip = await JSZip.loadAsync(res.data);
        const files = [];

        for (const filename of Object.keys(zip.files || {})) {
          const file = zip.files[filename];
          if (!file.dir && filename.toLowerCase().endsWith(".pdf")) {
            const content = await file.async("uint8array");
            const blob = new Blob([content], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);

            // store both URL & original filename
            files.push({ url, filename});
          }
        }
        setPdfFiles(files);
      }
    } catch (error) {
      console.error("Failed to fetch PDFs:", error);
      setPdfFiles([]);
    } finally {
      setPdfLoading(false);
    }
  };

  const handleSend = async () => {
    try {
      const userId = JSON.parse(localStorage.getItem("user"))?.id ?? "";
      const hasEmptyField = queries.some((q) => !q.query?.trim());

      if (hasEmptyField) {
        enqueueSnackbar("Please fill all required fields", {
          variant: "warning",
        });
        return;
      }
      const res = await ApiServices.post(`file/query/${id}/${userId}`, {
        queries,
      });
      if (res?.status === 200) {
        setQueryRows(res?.data);
        setQueries([{ category: "", requiredFiles: "", query: "" }]);
        enqueueSnackbar("Query Raised Successfully", { variant: "success" });
        setOpenDialog(false);
      } else {
        enqueueSnackbar("Query Raising Failure", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("Query Raising Failure", { variant: "error" });
    }
  };

  const handleDelete = async () => {
    try {
      if (!delReason.trim()) {
        enqueueSnackbar("Please provide a reason for deletion.", {
          variant: "warning",
        });
        return;
      }

      const userId = JSON.parse(localStorage.getItem("user"))?.id ?? "";

      const res = await ApiServices.put(
        `file/query/delete/${selectedQueryId}/${userId}`,
        { reason: delReason },
      );

      if (res?.status === 200) {
        setQueryRows(res?.data?.query);
        handleCloseDelModal();
        enqueueSnackbar("File deleted successfully.", { variant: "success" });
      } else {
        enqueueSnackbar("Failed to delete the file. Please try again.", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("An unexpected error occurred while deleting the file.", {
        variant: "error",
      });
    }
  };

  const fetchQueries = async () => {
    // setQueryLoading(true)
    try {
      const res = await ApiServices.get(`file/query/${id}`);
      if (res?.status === 200 && res?.data?.message === "Success") {
        setQueryRows(res?.data?.query);
      }
    } catch (error) {
      enqueueSnackbar("fetch query failed", { variant: "error" });
    } finally {
      // setQueryLoading(false)
    }
  };

  const fetchFile = async () => {
    try {
      const res = await ApiServices.get(
        `file/assigned-files/file-details/${id}`,
      );
      if (res?.status === 200) {
        const data = res?.data[0] ?? {};
        setFileRows({ ...data });
        handleSearchPolicy(data);
      }
    } catch (error) {
      enqueueSnackbar("fetch query failed", { variant: "error" });
    }
  };

  const handleAddQuery = () => {
    setQueries((prev) => [
      ...prev,
      { category: "", requiredFiles: "", query: "" },
    ]);
  };

  const handleRemoveQuery = (index) => {
    setQueries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCustomChange = (index, field, value) => {
    setQueries((prev) =>
      prev.map((q, i) => (i === index ? { ...q, [field]: value } : q)),
    );
  };

  const fetchOtherTabs = async () => {
    //await fetchTemplate();
    await fetchPDFs();
  };

  const fetchHintsTab = async () => {
    await fetchQueries();
    await fetchFile();
  };

  const handleStatusCheck = async () => {
    try {
      const userId = JSON.parse(localStorage.getItem("user"))?.id ?? "";
      const res = await ApiServices.get(`file/status-check/${id}`);
      if (
        res?.status === 200 &&
        res?.data?.status !== "In Progress" &&
        res?.data?.status !== "Completed"
      ) {
        if (Number(userId) === Number(res?.data?.assigned_to)) {
          setModalOpen(true);
          //enqueueSnackbar(`Status changed to "In Progress" successfully!`, { variant: "success" });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSave = async () => {
    try {
      const res = await ApiServices.put(`file/status-update/${id}`);
      if (res?.status === 200) {
        setModalOpen(false);
        enqueueSnackbar(`Status changed to "In Progress" successfully!`, {
          variant: "success",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (_, newTab) => {
    setTab(newTab);

    // 🔁 Reload ONLY overview editor
    if (newTab === 4) {
      setOverviewReloadKey((k) => k + 1);
    }

    requestAnimationFrame(() => {
      workEditorRef.current?.resizeEditor?.();
      overviewEditorRef.current?.resizeEditor?.();
    });
  };

  // ✅ Breadcrumb Navigation
  const renderBreadcrumbs = () => (
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ ml: 2 }}>
        <MUILink
          underline="hover"
          color="inherit"
          component="button"
          onClick={() => navigate(-1)}
          sx={{ display: "flex", alignItems: "center" }}
        >
          <ArrowBackIcon sx={{ mr: 0.5 }} fontSize="small" />
          Back
        </MUILink>
      </Breadcrumbs>
    </Box>
  );

  const handleFileUpload = async (tabs) => {
    try {
      setQueryLoading(true);

      const formData = new FormData();

      tabs?.forEach(({ category, files }) => {
        Array.from(files).forEach((file) => {
          formData.append(`files_${category.replace(/\s+/g, "_")}`, file);
        });
      });
      // Object.entries(tabs).forEach(([category, files]) => {
      //   Array.from(files).forEach((file) => {
      //     formData.append(`files_${category.replace(/\s+/g, "_")}`, file);
      //   });
      // });

      // const safeCategory = category.replace(/\s+/g, "_");

      // files.forEach((file) => {
      //   formData.append(`files_${safeCategory}`, file);
      // });

      const res = await ApiServices.put(
        `file/uploads/category/${id}/0`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (res?.status === 200) {
        setQueryRows(res?.data);
        enqueueSnackbar("File upload successfully", { variant: "success" });
      } else {
        enqueueSnackbar("File upload failed", { variant: "error" });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Error during File upload", { variant: "warning" });
    } finally {
      setQueryLoading(false);
      fetchPDFs();
    }
  };

  const handleOpenDeletedModal = async () => {
    setOpenDeletedModal(true);
    try {
      const res = await ApiServices.get(`/file/query/delete/${id}`);

      if (res?.status === 200) {
        setDeletedRows(res?.data?.query);
      }
    } catch (error) {
      enqueueSnackbar("Failed to load deleted files", { variant: "error" });
    }
  };

  const handleOpenQryUploadModal = () => {
    setOpenQryUploadModal(true);
  };

  const handleUploadFromDialog = async (tabs) => {
    await handleFileUpload(tabs);
  };

  const handleCloseDeletedModal = () => {
    setOpenDeletedModal(false);
    setDeletedRows([]);
  };

  const deletedColumns = [
    { field: "id", headerName: "Id", flex: 0.6 },

    { field: "category", headerName: "Category", flex: 1 },

    {
      field: "query",
      headerName: "Query",
      flex: 2,
    },

    {
      field: "reason",
      headerName: "Reason",
      flex: 2,
    },

    { field: "name", headerName: "Raised By", flex: 1 },

    {
      field: "created_at",
      headerName: "Created At",
      flex: 1,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD-MM-YYYY HH:mm:ss") : "",
    },

    {
      field: "deleted_by",
      headerName: "Deleted By",
      flex: 1,
    },

    {
      field: "deleted_at",
      headerName: "Deleted At",
      flex: 1,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD-MM-YYYY HH:mm:ss") : "",
    },
  ];

  const queryColumns = [
    // { field: 'id', headerName: 'Id', flex: 0.25, headerAlign: 'center' },

    /*{ field: 'category', headerName: 'Category', flex: 1, headerAlign: 'center' },

    {
      field: 'uploaded_count',
      headerName: 'Uploaded Files',
      flex: 1,
      headerAlign: 'center',
      renderCell: (params) => {
        const uploaded = Number(params.row.uploaded_count ?? 0);
        const required = Number(params.row.required_files_count ?? 0);
        return `${uploaded} / ${required}`;
      }
    }, */

    {
      field: "query",
      headerName: "Query",
      flex: 3,
      headerAlign: "center",
      renderCell: (params) => (
        <Box
          sx={{
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            lineHeight: 1.5,
            fontSize: "14px",
            p: 1,
            width: "100%",
            textAlign: "left",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    { field: "name", headerName: "Raised By", flex: 1, headerAlign: "center" },
    {
      field: "created_at",
      headerName: "Raised At",
      flex: 1,
      headerAlign: "center",
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD-MM-YYYY HH:mm:ss") : "",
    },
  ];

  const FileDetailTable = ({ file, detail }) => {
    const File = [
      { label: "File Number", value: file.file_number },
      { label: "Applicant Name", value: file.file_name },
      { label: "Bank", value: file.bank_name },
      { label: "Report Type", value: file.bank_product },
      { label: "Login Type", value: file.login_type },
      { label: "Application ID", value: file.application_id },
      {
        label: "Login Date",
        value: file.created_at
          ? dayjs(file.created_at).format("DD-MM-YYYY hh:mm:ss A")
          : "-",
      },
      { label: "Current Status", value: file.status },
      { label: "Initiated By", value: file.initiated_by },
      { label: "Assigned To", value: file.assigned_to || "-" },
      { label: "Waiting Time", value: file.waiting_time },
    ];

    const Property = [
      { label: "Property Owner Name", value: file.property_owner_name },
      { label: "Title Deed No", value: file.title_deed_no },
      { label: "Survey No", value: file.survey_no },
      { label: "Extent", value: file.extent },
    ];

    const rows = detail === "File" ? File : Property;

    return (
      <Card variant="outlined" sx={{ maxWidth: 600, mb: 1 }}>
        <CardContent sx={{ p: 1 }}>
          <Table size="small">
            <TableBody>
              {rows?.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      width: "40%",
                      p: "6px",
                      fontSize: "0.8rem",
                    }}
                  >
                    {row?.label}
                  </TableCell>
                  <TableCell sx={{ p: "6px", fontSize: "0.8rem" }}>
                    {row?.value || "-"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  };

  useEffect(() => {
    if (!hasFetched.current) {
      fetchHintsTab();
      fetchOtherTabs();
      hasFetched.current = true;
    }
  }, []);

  // Policy tab
  // const [banks, setBanks] = useState([]);
  // const [products, setProducts] = useState([]);
  // const [selectedBank, setSelectedBank] = useState("");
  // const [selectedProduct, setSelectedProduct] = useState("");
  const [policy, setPolicy] = useState("");

  // Fetch banks/products info when tab opens
  // useEffect(() => {
  //if (tab === 4) {
  // fetchBankProductsInfo();
  //}
  // }, []);

  /*   useEffect(() => {
    if (tab === 4) {
      handleSearchPolicy();
    }
  }, [tab]); */

  // const fetchBankProductsInfo = async () => {
  //   try {
  //     const res = await ApiServices.get("user/get-bank-products-info");
  //     if (res?.status === 200) {
  //       const data = res.data || [];
  //       setProducts(data);

  //       // Extract distinct banks
  //       const distinctBanks = Array.from(
  //         new Map(
  //           data.map((item) => [item.bank_id, { bank_id: item.bank_id, bank_name: item.bank_name }])
  //         ).values()
  //       );
  //       setBanks(distinctBanks);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching bank products info:", error);
  //   }
  // };

  const handleSearchPolicy = async (file) => {
    try {
      /* if (!selectedBank || !selectedProduct) {
        setPolicy("Please select both Bank and Product.");
        return;
      } */

      const res = await ApiServices.get(`user/get-policy/file/${file.id}`);

      if (res?.status === 200 && res?.data?.length > 0) {
        setPolicy(res.data[0].policy || "No policy found");
      } else {
        setPolicy("No policy found");
      }
    } catch (error) {
      console.error("Error fetching policy:", error);
      setPolicy("Error fetching policy");
    }
  };

  // console.log("fileRows------>", fileRows)
  return (
    <>
      <Box sx={{ width: "100%", pt: "0" }}>
        <Tabs
          value={tab}
          onChange={handleChange}
          centered
          variant="scrollable"
          scrollButtons="auto"
          textColor="primary"
          indicatorColor="primary"
          sx={{ borderBottom: 1, borderColor: "divider", padding: "0" }}
        >
          <Tab
            label="Hints About File"
            sx={{ pt: "0", pb: "0", mt: "0", mb: "0" }}
          />
          <Tab label="Work File" sx={{ pt: "0", pb: "0", mt: "0", mb: "0" }} />
          {/* <Tab label="Final Report" /> */}
          <Tab label="Formats" sx={{ pt: "0", pb: "0", mt: "0", mb: "0" }} />
          <Tab label="Policy" sx={{ pt: "0", pb: "0", mt: "0", mb: "0" }} />
          <Tab
            label="Report Overview"
            sx={{ pt: "0", pb: "0", mt: "0", mb: "0" }}
          />
        </Tabs>

        <Box sx={{ display: tab === 0 ? "block" : "none" }}>
          <Grid container spacing={2} sx={{ width: "100%" }}>
            <Grid item xs={12} md={6} sx={{ width: "74%" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
                  File Hints:
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mr: 2, mt: 1 }} // space to the right and top
                  onClick={handleOpenQryUploadModal}
                >
                  Upload Queries
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  sx={{ mr: 2, mt: 1 }} // space to the right  and top
                  onClick={handleOpenDeletedModal}
                >
                  Deleted Queries
                </Button>

                {(userRole === "Super Admin" ||
                  userRole === "Branch Admin") && (
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ mr: 2, mt: 1 }} // space to the right  and top
                    onClick={setQryToBankStatus}
                  >
                    Set Query to Bank
                  </Button>
                )}
              </Box>

              {/* 🔹 GRID + LOADER OVERLAY */}
              <Box sx={{ position: "relative", height: 400, width: "100%" }}>
                <DataGrid
                  rows={queryRows}
                  columns={queryColumns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  disableSelectionOnClick
                  getRowHeight={() => "auto"}
                  getColumnHeaderHeight={() => "auto"} // ✅ IMPORTANT
                  sx={{
                    "& .MuiDataGrid-cell": {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      whiteSpace: "normal",
                      lineHeight: 1.5,
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                      whiteSpace: "normal", // allow wrap
                      lineHeight: 1.2,
                      textAlign: "center",
                      fontWeight: 600,
                    },
                    "& .MuiDataGrid-columnHeader": {
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px",
                    },
                  }}
                />

                {/* 🔹 LOADER OVERLAY */}
                {queryLoading && (
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(255,255,255,0.6)",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 10,
                    }}
                  >
                    <CircularProgress />
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1.5,
                        fontWeight: 700,
                        color: "rgba(0,0,0,0.87)",
                      }}
                    >
                      Please wait, uploading file...
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpenDialog}
                >
                  Add Hint
                </Button>
              </Box>
            </Grid>

            {/* 🔹 RIGHT SIDE */}
            <Grid item xs={12} md={6} sx={{ height: 400, width: "24%" }}>
              <Typography variant="subtitle1" gutterBottom>
                File Details:
              </Typography>
              {fileRows && <FileDetailTable file={fileRows} detail="File" />}

              <Typography variant="subtitle1" gutterBottom>
                Property Details:
              </Typography>
              {fileRows && (
                <FileDetailTable file={fileRows} detail="Property" />
              )}
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ display: tab === 1 ? "block" : "none" }}>
          <Box>
            <Grid container spacing={2} style={{ width: "100%" }}>
              <Grid item xs={12} md={6} style={{ width: "49%" }}>
                {pdfLoading ? (
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    style={{ height: "100%" }}
                  >
                    <Grid item>
                      <Typography variant="h6" gutterBottom>
                        Please wait while the PDF is loading...
                      </Typography>
                    </Grid>
                    <Grid item>
                      <CircularProgress />
                    </Grid>
                  </Grid>
                ) : (
                  <Paper
                    sx={{
                      height: 518,
                      display: "flex",
                      flexDirection: "column",
                      p: 2,
                    }}
                  >
                    <Box sx={{ flex: 1, overflowY: "auto" }}>
                      {pdfFiles?.length > 0 ? (
                        <SinglePdfViewer pdfFiles={pdfFiles} />
                      ) : (
                        // pdfFiles?.map((url, index) => (
                        //   <iframe
                        //     key={index}
                        //     src={url}
                        //     width="100%"
                        //     height="100%"
                        //     style={{ marginBottom: 10, border: "1px solid #ccc" }}
                        //     title={`pdf-${index}`}
                        //   />
                        // ))
                        <Typography>No PDFs found</Typography>
                      )}
                    </Box>
                  </Paper>
                )}
              </Grid>

              <Grid item xs={12} md={6} style={{ width: "49%" }}>
                <Paper
                  sx={{
                    height: "calc(100vh - 70px)",
                    display: "flex",
                    flexDirection: "column",
                    p: 2,
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      minHeight: 0, // ✅ REQUIRED
                      width: "100%", // ✅ REQUIRED
                    }}
                  >
                    <SyncfusionWordEditor
                      ref={workEditorRef}
                      fileId={id}
                      onChange={setEditorContent}
                    />
                  </Box>
                </Paper>
              </Grid>
            </Grid>

            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                color="success"
                onClick={() => setOpenConfirm(true)}
              >
                Complete Report
              </Button>
              <Button
                variant="contained"
                sx={{ mr: 2 }}
                color="warning"
                onClick={handleOpenDialog}
              >
                Raise Query
              </Button>
              <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveFile}
                  disabled={saveLoading}
                  startIcon={
                    saveLoading ? <CircularProgress size={18} color="inherit" /> : null
                  }
                >
                  {saveLoading ? "Saving..." : "Save File"}
                </Button>
            </Box>
          </Box>
        </Box>

        <Box sx={{ display: tab === 4 ? "block" : "none" }}>
          <Box
            sx={{
              minHeight: "calc(100vh - 100px)",
              p: 2,
              display: "flex",
              gap: 2,
              alignItems: "flex-start",
            }}
          >
            {/* ------------ CENTER DOCUMENT AREA ------------ */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paper
                sx={{
                  width: "816px", // A4 width
                  height: "calc(100vh - 70px)", // ✅ enough space
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: 3,
                  borderRadius: 2,
                }}
              >
                {/* 🚫 NO overflow wrapper here */}
                <Box sx={{ flex: 1 }}>
                  <SyncfusionWordEditor
                    ref={overviewEditorRef}
                    fileId={id}
                    reloadKey={overviewReloadKey}
                    onChange={setOVEditorContent} // optional, read-only if needed
                  />
                </Box>
              </Paper>
            </Box>

            {/* ------------ RIGHT SIDEBAR ------------ */}
            <Box
              sx={{
                width: "180px",
                display: "flex",
                flexDirection: "column",
                gap: 2,
                position: "sticky",
                top: 20,
              }}
            >
              <Button
                variant="contained"
                fullWidth
                onClick={() => setOpenConfirm(true)}
                sx={{ py: 2, fontWeight: "bold" }}
                color="success"
              >
                COMPLETE REPORT
              </Button>

              <Button
                variant="contained"
                fullWidth
                onClick={handleOpenDialog}
                color="warning"
                sx={{ py: 2, fontWeight: "bold" }}
              >
                RAISE QUERY
              </Button>

              <Button
                variant="contained"
                fullWidth
                onClick={handleSaveFile}
                disabled={saveLoading}
                sx={{ py: 2, fontWeight: "bold" }}
                startIcon={
                  saveLoading ? <CircularProgress size={18} color="inherit" /> : null
                }
              >
                {saveLoading ? "SAVING..." : "SAVE FILE"}
              </Button>
              <Button onClick={() => overviewEditorRef.current?.exportDocx()}>
                Export DOCX
              </Button>

              <Button
                onClick={() => overviewEditorRef.current?.exportPdf(`${id}`, `${fileRows.file_name}`)}
              >
                Export PDF
              </Button>
            </Box>
          </Box>
        </Box>

        {tab === 2 && <FileFormatComponent />}

        {tab === 3 && (
          <Box sx={{ p: 3 }}>
            {/* Policy Text Area */}
            <TextField
              label="Policy"
              value={policy}
              fullWidth
              multiline
              rows={10}
              InputProps={{ readOnly: true }}
            />
          </Box>
        )}

        {renderBreadcrumbs()}
      </Box>

      {/* Modal for Raise Query */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2, p: 3, backgroundColor: "#fff" },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            color: "#333",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Raise Query</Typography>

          <Button
            size="small"
            variant="contained"
            color="primary"
            disabled={queries?.length >= 5}
            onClick={handleAddQuery}
            sx={{
              textTransform: "none",
              borderRadius: 1,
            }}
          >
            + Add Another Query
          </Button>
        </DialogTitle>

        <DialogContent dividers>
          {queries?.map((data, index) => (
            <Box
              key={index}
              sx={{
                mb: 3,
                p: 2,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
              }}
            >
              <Grid container spacing={2}>
                {/* <Grid item xs={12} style={{ width: "40%" }}>
                  <FormControl fullWidth size="small">
                    <InputLabel id="category-label"> Category </InputLabel>

                    <Select
                      labelId="category-label"
                      value={data.category}
                      label="Category"
                      onChange={(e) => handleCustomChange(index, "category", e.target.value)}
                    >
                      {arrDocumentCategory?.map((cat) => (
                        <MenuItem key={cat} value={cat}>
                          {cat}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} style={{ width: "40%" }}>
                  <TextField
                    fullWidth
                    size="small"
                    label="No. Of files required"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={data.requiredFiles}
                    onChange={(e) => handleCustomChange( index, "requiredFiles", Number(e.target.value) )}
                  />
                </Grid>

                <Grid item xs={12} style={{ width: "10%" }} >
                  {queries?.length > 1 && (
                    <IconButton
                      color="error"
                      onClick={() => handleRemoveQuery(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Grid> */}

                <Grid item xs={12} style={{ width: "100%" }}>
                  <TextField
                    fullWidth
                    label="Message"
                    variant="outlined"
                    multiline
                    value={data.query}
                    onChange={(e) =>
                      handleCustomChange(index, "query", e.target.value)
                    }
                    rows={6}
                    InputProps={{
                      sx: {
                        fontSize: "1rem", // optional styling
                        lineHeight: 1.0,
                      },
                    }}
                    sx={{
                      width: "100%", // ensure it fills parent
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2} alignItems="center"></Grid>
            </Box>
          ))}
        </DialogContent>

        <DialogActions sx={{ mt: 2 }}>
          <Button onClick={handleCloseDialog} variant="contained">
            Cancel
          </Button>
          <Button onClick={handleSend} variant="contained" color="primary">
            Send
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal for status check */}
      <Dialog open={modalOpen} onClose={handleCloseModal}>
        <DialogTitle>Save Changes?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <>
              <strong> Do you want to resume the work? </strong>{" "}
              <p>
                Note: The status will change to "In Progress" only if you click
                "Yes".
              </p>
            </>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">
            No
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            variant="contained"
            startIcon={<SaveIcon />}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal for File delete */}
      <Dialog
        open={openDelModal}
        onClose={handleCloseDelModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 3,
            backgroundColor: "#fff",
          },
        }}
      >
        {/* <DialogTitle sx={{ fontWeight: "bold", color: "#333", mb: 2 }}>
          Delete File
        </DialogTitle> */}
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ width: "100%" }}>
              <TextField
                fullWidth
                label="Reason"
                variant="outlined"
                multiline
                value={delReason}
                onChange={(e) => setDelReason(e.target.value)}
                rows={6}
                InputProps={{
                  sx: {
                    fontSize: "1rem", // optional styling
                    lineHeight: 1.5,
                  },
                }}
                sx={{
                  width: "100%", // ensure it fills parent
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ mt: 2, pr: 2 }}>
          <Button
            onClick={handleCloseDelModal}
            variant="contained"
            sx={{ borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            variant="contained"
            color="primary"
            sx={{ borderRadius: 2 }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal for deleted columns */}

      <Dialog
        open={openDeletedModal}
        onClose={handleCloseDeletedModal}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Deleted Query Hints</DialogTitle>

        <DialogContent dividers>
          <DataGrid
            rows={deletedRows}
            columns={deletedColumns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            autoHeight
            getRowHeight={() => "auto"}
            disableSelectionOnClick
            sx={{
              "& .MuiDataGrid-cell": {
                whiteSpace: "normal",
                lineHeight: 1.5,
                alignItems: "center",
              },
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDeletedModal} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <UploadQueryFilesDialog
        openDialog={openQryUploadModal}
        handleCloseDialog={() => setOpenQryUploadModal(false)}
        arrDocumentCategory={arrDocumentCategory}
        handleFileUpload={handleUploadFromDialog}
      />

      {/* Dialog for Complete Report Confirmation */}
      <Dialog
        open={openConfirm}
        onClose={handleCancelComplete}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: 6,
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle
          sx={{
            px: 3,
            py: 2.5,
            fontSize: "1.25rem",
            fontWeight: 600,
            color: "#212121",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          Confirm Report Completion
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 3 }}>
          <DialogContentText
            sx={{
              fontSize: "1rem",
              lineHeight: 1.7,
              color: "#424242",
            }}
          >
            Are you sure you want to mark this report as completed?
          </DialogContentText>

          <DialogContentText
            sx={{
              mt: 1,
              fontSize: "0.875rem",
              color: "#757575",
            }}
          >
            Please ensure that all required details have been reviewed
            before confirming completion.
          </DialogContentText>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2,
            gap: 1.5,
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <Button
            variant="outlined"
            onClick={handleCancelComplete}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              px: 2.5,
              borderColor: "#bdbdbd",
              color: "#424242",
              "&:hover": {
                borderColor: "#757575",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={handleConfirmComplete}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              px: 2.5,
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#1b5e20",
                boxShadow: "none",
              },
            }}
          >
            Confirm Completion
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
